import { ReservedLocation } from './reservedLocation';
import { Account } from './account';
export class AccountReservedLocation {

    public account: Account
    public reservedLocations: ReservedLocation[]

    constructor(
        account: Account,
        reservedLocations: ReservedLocation[],
    ) {
        this.account = account;
        this.reservedLocations = reservedLocations
    }

}
